export const buildFirewallServicesStatusData = services => ([{
    name: 'Firewall',
    status: services.status
}, {
    name: 'dashboard:failed_attempts',
    status: services.status_f2b
}, {
    name: 'dashboard:port_scanning',
    status: services.status_pe
}]);
